const ambassadors = {
  name: 'Ambassador Name',
};

export default ambassadors;
